<template>
  <div>
    <h1 class="show-in-mobile">Administradores</h1>
    <div class="filter-container" style="margin-bottom:10px; text-align:left">
      <span style="margin-right: 10px">Filtrar</span>
      <el-input
        v-model="search"
        size="mini"
        placeholder="Nombre"
        style="width: 150px; margin-right:5px"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-download"
        size="mini"
        @click="handleDownload"
        :loading="loadingExportButton"
      >
        <span v-if="!is_mobile">Exportar</span>
      </el-button>
      <el-button
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-plus"
        size="mini"
        @click="handleCreate"
      >
        <span v-if="!is_mobile">Nuevo administrador</span>
      </el-button>
    </div>
    <el-table
      v-loading="loading"
      element-loading-text="Cargando..."
      :data="roleList.filter(data => !search || data.full_name.toLowerCase().includes(searchInLowerCase))"
      ref="roleListFiltered"
      :default-sort="{prop: 'full_name', order: 'ascending'}"
      style="width: 100%"
    >
      <el-table-column
        prop="status"
        label="Estado"
        width="100"
        :filters="[{ text: 'Inactivo', value: false }, { text: 'Activo', value: true }]"
        :filter-method="filterStatus"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.is_active ? 'success' : 'danger'"
            @click="handleStatus(scope.row)"
            style="cursor:pointer;"
            disable-transitions
          >{{scope.row.is_active ? 'Activo' : 'Inactivo'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Apellido y Nombre" prop="full_name" sortable min-width="200"></el-table-column>
      <el-table-column label="Permisos" sortable prop="role_t" min-width="120"></el-table-column>
      <el-table-column label="Descripción" prop="desc" min-width="220"></el-table-column>
      <el-table-column align="right" min-width="120">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)" icon="el-icon-edit" />
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
            icon="el-icon-delete"
          />
        </template>
      </el-table-column>
    </el-table>

    <!-- Form -->
    <el-dialog
      :title="modal.name"
      :visible.sync="dialogFormVisible"
      width="500px"
      @close="handleDialogClose()"
    >
      <el-form :model="form" ref="form" :rules="rules" :label-width="formLabelWidth">
        <el-form-item label="Apellido y Nombre" prop="full_name">
          <el-input v-model="form.full_name" autocomplete="off" :disabled="modal.readOnly"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="form.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="!modal.readOnly" label="Contraseña" prop="password">
          <el-input v-model="form.password" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item v-if="!modal.readOnly" label="Re-Contraseña" prop="re_password">
          <el-input v-model="form.re_password" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item label="Permisos" prop="role">
          <el-select v-model="form.role" placeholder="Seleccione">
            <el-option
              v-for="role in roles"
              :key="role.value"
              :label="role.label"
              :value="role.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Estado" style="text-align:left">
          <el-switch v-model="form.is_active"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancelar</el-button>
        <el-button :loading="loadingSaveButton" type="primary" @click="handleSaveButton('form')">Guardar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cleanObject from '@/vendor/CleanObject'

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "" && this.form.password === "") {
        callback(new Error("Debe ingresar una contraseña"));
      } else if (value !== this.form.password) {
        callback(new Error("Las dos contraseñas deben coincidir"));
      } else if (value && value.length < 6) {
        callback(new Error("La contraseña debe tener al menos 6 letras"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      loadingExportButton: false,
      loadingSaveButton: false,
      search: "",
      dialogFormVisible: false,
      rules: {
        full_name: [
          {
            required: true,
            message: "Debe ingresar un nombre",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "Debe ingresar un email",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Debe ingresar una contraseña",
            trigger: "blur"
          }
        ],
        re_password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        role: [
          {
            required: true,
            message: "Debe seleccionar un rol de administrador",
            trigger: "change"
          }
        ],
      },
      form: {
        full_name: '',
        email: '',
        password: '',
        re_password: '',
        role: '',
        is_active: true
      },
      formLabelWidth: "150px",
      modal: {
        name: "",
        status: "",
        readOnly: false,
      }
    };
  },
  async created() {
    this.$store.commit("CHANGE_SECTION", { name: "Administradores", index: "5" });

    this.loading = true;
    await this.$store.dispatch("getRoles");
    this.loading = false;
  },
  methods: {
    msgSuccess(text){
      this.$message({
        type: "success",
        message: text
      });
    },
    msgError(text) {
      this.$message({
        type: "error",
        showClose: true,
        duration: 0,
        message: text
      });
    },
    filterStatus(value, row) {
      return row.is_active === value;
    },
    handleCreate() {
      this.modal = { name: "Nuevo administrador", status: "add", readOnly: false };
      this.dialogFormVisible = true;
    },
    handleEdit(row) {
      this.modal = { name: "Editar administrador", status: "edit", readOnly: true };
      this.form = { ...row };
      this.dialogFormVisible = true;
    },
    handleSaveButton(formName) {
      this.$refs[formName].validate( async valid => {
        if (valid) { // Valid form
          this.loadingSaveButton = true
          
          /* // Create user role
          const role = {
            auth_id: user.user.uid,
            full_name: this.name,
            is_active: false,
            role: 'commercial',
          }
          this.$store.dispatch("addRole", role)
           */
          if (this.modal.status === "add") {
            await this.$store.dispatch("addRole", {...this.form})
            .then(() => {
              this.msgSuccess("El administrador fue agregado")
            })
            .catch(() => {
              this.msgError("Hubo un error agregando el administrador")
            })
            
          } else {
            await this.$store.dispatch("updateRole", {...this.form})
            .then(() => {
              this.msgSuccess("El administrador fue actualizado")
            })
            .catch(() => {
              this.msgError("Error actualizando el administrador, probablemente ya no exista en la base de datos. Recargue la página")
            })
          }
          this.loadingSaveButton = false
          this.dialogFormVisible = false
        }
      });
    },
    handleDialogClose() {
      // Reset form validations
      this.$refs["form"].resetFields();
      cleanObject(this.form);
      this.form.is_active = true;
    },
    handleDelete(row) {
      this.$confirm(
        "Estás por borrar completamente el administrador " + row.full_name,
        "Borrar",
        {
          confirmButtonText: "Borrar",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      )
      .then(() => {
        this.$store.dispatch("deleteRole", row)
        .then(() => {
          this.msgSuccess("El administrador fue eliminado")
        })
        .catch(() => {
          this.msgError("Error eliminando el administrador")
        })
      })
      .catch(() => {})
    },
    handleStatus(row) {
      const statusText = row.is_active ? "Desactivar" : "Activar";
      this.$confirm(
        "Desea " + statusText.toLowerCase() + " el administrador " + row.full_name,
        statusText,
        {
          confirmButtonText: statusText,
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      )
        .then(() => {
          this.$store.dispatch("toggleStatusRole", row)
          .then(() => {
            this.msgSuccess("El administrador fue actualizado")
          })
          .catch(() => {
            this.msgError("Error actualizando el administrador, probablemente ya no exista en la base de datos. Recargue la página")
          })
        })
        .catch(() => {})
    },
    handleDownload() {
      this.loadingExportButton = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "Estado",
          "Apellido y Nombre",
          "Permisos",
        ];
        const filterVal = [
          "is_active",
          "full_name",
          "role",
        ];
        const data = this.formatJson(filterVal);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "administradores"
        });
        this.loadingExportButton = false;
      });
    },
    formatJson(filterVal) {
      // Export only visible elements, if use filter, only export filtered elements
      return this.$refs.roleListFiltered.tableData.map(v =>
        filterVal.map(j => {
          if (j === "is_active") {
            return v.is_active ? "Activo" : "Inactivo";
          } else {
            return v[j];
          }
        })
      );
    }
  },
  computed: {
    searchInLowerCase() {
      return this.search.toLowerCase().trim();
    },
    is_mobile() {
      return this.$store.state.is_mobile;
    },
    roleList() {
      return this.$store.state.roles.list;
    },
    roles() {
      // Never mutate data in computed properties 
      let roles = [...this.$store.state.roles.roles]
      // Order by name
      roles.sort(function(a, b) {
        var nameA = a.label.toUpperCase(); // ignore upper and lowercase
        var nameB = b.label.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      return roles
    },
  }
};
</script>